import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { postSelfServeAmend } from 'src/api/amendService';

import { ProcessSelfServeAmendDto } from '../../api/amendService/dto/ProcessSelfServeAmend.dto';

export const usePostSelfServeAmend = () =>
    useMutation<string, AxiosError, { payload: ProcessSelfServeAmendDto; bookingId: string }>({
        mutationKey: ['process-self-serve-amend'],
        mutationFn: ({ payload, bookingId }) => postSelfServeAmend(payload, bookingId),
    });
